export const getFullFio = (
  lastname?: string,
  firstname?: string,
  middlename?: string
) => {
  if (!lastname || !firstname) return '';
  return `${lastname} ${firstname} ${middlename ?? ''}`;
};
